import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Box } from "@ogt/ui";
import { Progressbar } from "@ogt/ui";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { handleSubmitClick } from "@ogt/ui";
import { ErrorList, InputText, SelectInput, Button, Heading } from "@ogt/ui";

export const radiotest_TICKET = "ticket";
export const radiotest_TAXI = "taxi";
export const radiotest_CAR = "car";

export default function ContactDetails() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const atLeastSixDigits = /\d{6,}/;
  const noDigits = /^[^\d]*$/;
  const progress = 64;

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/summering");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          travelQty: Yup.string().required("Vänligen ange antal resenärer"),
          contactperson: Yup.string()
            .required("Vänligen ange namn på kontaktperson")
            .matches(noDigits, "Namnet får inte innehålla siffror"),
          phonenumberschoolorg: Yup.string()
            .required("Vänligen ange telefonnummer")
            .matches(
              atLeastSixDigits,
              "Telefonnumret måste innehålla minst 6 siffror"
            ),
          mailadress: Yup.string()
            .required("Vänligen ange mejladress")
            .email("Vänligen ange en korrekt mejladress"),
          phonenumber: Yup.string()
            .required("Vänligen ange telefonnummer")
            .matches(
              atLeastSixDigits,
              "Telefonnumret måste innehålla minst 6 siffror"
            ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  className="mb-8"
                  headingRef={h2Ref}
                  id="contactsDetailsHeading"
                  focusable
                >
                  Vilka är ni som ska resa?
                </Heading>

                <Heading as="h3">Bra att tänka på</Heading>
                <ul className="mb-8">
                  <li>
                    Rullstol och barnvagn kan bara tas med i mån av plats.
                  </li>
                  <li>
                    Reser ni med kulturbiljetten får upp till 30 personer resa
                    på biljetten, varav minst 1 och max 4 personer ska vara
                    vuxna.
                  </li>
                </ul>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="schoolorg"
                  label={
                    <>
                      Skola/Organisation <span>(Frivilligt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"text"}
                />

                <SelectInput
                  name="travelQty"
                  label={
                    <>
                      Antal resande <span>(Obligatoriskt)</span>
                    </>
                  }
                  options={Array.from({ length: 30 }, (_, i) => i + 1)}
                />

                <InputText
                  name="contactperson"
                  label={
                    <>
                      Kontaktperson <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"text"}
                />

                <InputText
                  name="phonenumberschoolorg"
                  label={
                    <>
                      Telefonnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"text"}
                  numbersOnly
                />

                <InputText
                  name="mailadress"
                  label={
                    <>
                      Mejladress <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="email"
                  autocomplete={"email"}
                />

                <Heading as="h3">Hur når vi er under resan?</Heading>

                <p>
                  Vi behöver ett telefonnummer till någon som ska vara med på
                  resan, ifall vi skulle behöva komma i kontakt med er under
                  resdagen.
                </p>

                <InputText
                  name="phonenumber"
                  label={
                    <>
                      Telefonnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  numbersOnly
                  autocomplete={"text"}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
